import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
} from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (localStorage.getItem("currentUser") === null) {
      const customReq = request.clone({
        // headers: request.headers.set("content-type", "application/json"),
      });

      // pass on the modified request object
      return next.handle(customReq).pipe(
        tap((ev: HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {
          }
        }),
        catchError((response) => {
          if (response instanceof HttpErrorResponse) {
            console.log("Processing http error", response);
          }
          return throwError(response);
        })
      );
    } else {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      // console.log("interceptor====>", userData);
      const contactno =
        userData && userData !== null && userData.contactno
          ? userData.contactno
          : null;
      const cloudsecretuser =
        userData && userData !== null && userData.cloudsecretuser
          ? userData.cloudsecretuser
          : null;
      const token =
        userData && userData !== null && userData.token ? userData.token : null;
      // console.log('contactno======', contactno);

      const customReq = request.clone({
        headers: new HttpHeaders({
          Accept: "application/json",
          Authorization: token,
          userid: String(contactno),
          secretuser: cloudsecretuser,
        }),
      });

      // console.log('customReq===', customReq);
      // pass on the modified request object
      return next.handle(customReq).pipe(
        tap((ev: HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {
            // console.log('processing response', ev);
          }
        }),
        catchError((response) => {
          if (response instanceof HttpErrorResponse) {
            // console.log('Processing http error', response);
          }
          return throwError(response);
        })
      );
    }
  }
}